import { track, disableTracking } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'control_install';


export default (eventProps = null, done = () => {}) => {
  track(EVENT_NAME, eventProps, { once: true, important: true, force: true }, done);
  disableTracking();
};



// WEBPACK FOOTER //
// ./src/lib/track-event/install.js